import React from 'react';

/**
 * InsuranceServiceIcon Icon - Used in serviceSplit page
 */
export const InsuranceServiceIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_11409_6753)">
        <path d="M8.38477 15V1" stroke="#212121" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M2.76074 8.5H14.0101"
          stroke="#212121"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.38509 1C7.10592 2.4 4.97428 3.8 1.98926 4.267C1.98926 4.267 1.98926 12.2 8.38509 15C14.7809 12.2 14.7809 4.267 14.7809 4.267C11.7959 3.8 9.66426 2.4 8.38509 1Z"
          stroke="#212121"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11409_6753">
          <rect width="14.619" height="16" fill="white" transform="translate(0.619141)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default InsuranceServiceIcon;
